import {Table, TBody, TD, THead, TR} from "../../../components/Table";
import {css} from "glamor";
import React from "react";
import {DateTime} from "luxon";

const urlStyles = css({
  cursor: "pointer",
  transition: "background 0.2s",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
});
const formattedDate = (date, zone = 'utc') => {
  if (!date) return '-';

  let dt;

  if (typeof date === 'number') { // already a number (millis)
    dt = DateTime.fromMillis(date, { zone: 'utc' });
  }
  else if (typeof date === 'string' && /^\d+$/.test(date)) { // numeric string (timestamp in millis)
    dt = DateTime.fromMillis(Number(date), { zone: 'utc' });
  }
  else if (typeof date === 'string') {// ISO string
    dt = DateTime.fromISO(date, { zone: 'utc' });
  }
  else {
    return '-';
  }

  if (!dt.isValid) return '-';

  return dt.setZone(zone).toFormat('d MMM yyyy HH:mm');
};

/** No gate of their own — each call site applies its own permission gating. */
export const questTable = (charges, zone, renderApproved = false, isPayout = false) => {
  return charges?.length ? (
        <Table spaceBelow='medium'>
          <THead>
            <tr>
              <th>Amount</th>
              <th>Plate</th>
              <th>{isPayout ? 'Created At' : 'Approved At'}</th>
              {renderApproved ? <th>Approved</th> : null}
            </tr>
          </THead>
          <TBody>
            {charges.map((charge, index) => (
              <TR className={urlStyles} key={`${index}-${charge.id}=${charge.updatedAt}`}>
                <TD>${(Number(charge.amount) / 100).toFixed(2)}</TD>
                <TD>{charge.plate}</TD>
                <TD>
                  {formattedDate(isPayout ? Number(charge.createdAt) : charge.GatewayCreatedAt, zone)}
                </TD>
                {renderApproved ? <TD>{charge.approved ? '✅' : '❌'}</TD> : null}
              </TR>
            ))}
          </TBody>
        </Table>
    ) :
    <div className={css({textAlign: "center", marginTop: '2rem'})}>
      No charges found.
    </div>;
}

const approvedValueWithRefunds = (charge) => {
  if (charge.requestedRefundAt && charge.processedRefundAt) return '🔁';
  return charge.approved === 'true' ? '✅' : '❌';
}

export const stripeTable = (charges, installation, zone, renderApproved = false) =>{
  return charges?.length ? (
        <Table spaceBelow='medium'>
          <THead>
            <tr>
              <th>Total</th>
              <th>Hotel</th>
              <th>Service</th>
              <th>Created At</th>
              <th>Guest Name</th>
              <th>Guest Email</th>
              <th>Plate</th>
              <th>Start</th>
              <th>End</th>
              {renderApproved ? <th>Approved</th> : null}
            </tr>
          </THead>
          <TBody>
            {charges.map((charge, index) => (
              <TR
                className={urlStyles}
                key={`${index}-${charge.stripeChargeId || charge.bookingId}-${charge.createdAt}`}
                onClick={() => {
                  window.open(
                    `/${installation.brandingKey}/bookings/${charge.bookingId}`,
                    "_blank"
                  );
                }}
              >
                <TD>${Number(charge.amountAud).toFixed(2)}</TD>
                <TD>${Number(charge.amountAudHotel).toFixed(2)}</TD>
                <TD>${Number(charge.amountAudService).toFixed(2)}</TD>
                <TD>{formattedDate(charge.createdAt, zone)}</TD>
                <TD>{charge.guestName}</TD>
                <TD>{charge.guestEmail}</TD>
                <TD>{charge.plate}</TD>
                <TD>{formattedDate(charge.booking_start, zone)}</TD>
                <TD>{formattedDate(charge.booking_end, zone)}</TD>
                {renderApproved ? <TD>{approvedValueWithRefunds(charge)}</TD> : null}
              </TR>
            ))}
          </TBody>
        </Table>
    ) :
    <div className={css({textAlign: "center", marginTop: '2rem'})}>
      No charges found.
    </div>;
}
